import React from 'react'

import { Col, DataContainer, Row } from 'Components/shared/Container'
import { H2, Text } from 'Components/shared/Typography'
import Input from 'Components/shared/Input'

import styled from '@emotion/styled'
import { Flex } from 'lese'

const InputContainer = styled(Flex)`
  grid-column: 1;
  margin: 16px;
  max-height: 5em;
  align-self: center;
  width: 66%;
`

export default ({ club, setSelectedClub }) => {
  return (
    <>
      <DataContainer>
        <Row style={{ margin: '10px' }}>
          <H2>Homepage Links</H2>
        </Row>
        <Row style={{ margin: '10px' }}>
          <Col style={{ width: '50%' }}>
            <Row>
              <Text style={{ paddingRight: '25px' }}>Button Label: </Text>
              <InputContainer>
                <Input
                  value={club.mainbtn1?.title._text ? decodeURI(club.mainbtn1.title._text) : ''}
                  style={{ width: '100%' }}
                  fullWidth
                  onChange={e => {
                    setSelectedClub({
                      ...club,
                      mainbtn1: { ...club.mainbtn1, title: { _text: e.target.value } }
                    })
                  }}
                />
              </InputContainer>
            </Row>
          </Col>
          <Col style={{ width: '50%' }}>
            <Row>
              <Text style={{ paddingRight: '25px' }}>Button Link: </Text>
              <InputContainer>
                <Input
                  value={
                    club.mainbtn1?.url._text
                      ? decodeURI(
                          club.mainbtn1?.url._text
                            .replace(/[⁄]/gm, `/`)
                            .replace(/&amp;frasl;|&frasl;/g, '/')
                        )
                      : ''
                  }
                  style={{ width: '100%' }}
                  fullWidth
                  onChange={e => {
                    setSelectedClub({
                      ...club,
                      mainbtn1: { ...club.mainbtn1, url: { _text: e.target.value } }
                    })
                  }}
                />
              </InputContainer>
            </Row>
          </Col>
        </Row>
        <Row style={{ margin: '10px' }}>
          <Col style={{ width: '50%' }}>
            <Row>
              <Text style={{ paddingRight: '25px' }}>Button Label: </Text>
              <InputContainer>
                <Input
                  value={club.mainbtn2?.title._text ? decodeURI(club.mainbtn2.title._text) : ''}
                  style={{ width: '100%' }}
                  fullWidth
                  onChange={e => {
                    setSelectedClub({
                      ...club,
                      mainbtn2: { ...club.mainbtn2, title: { _text: e.target.value } }
                    })
                  }}
                />
              </InputContainer>
            </Row>
          </Col>
          <Col style={{ width: '50%' }}>
            <Row>
              <Text style={{ paddingRight: '25px' }}>Button Link: </Text>
              <InputContainer>
                <Input
                  value={
                    club.mainbtn2?.url._text
                      ? decodeURI(
                          club.mainbtn2?.url._text
                            .replace(/[⁄]/gm, `/`)
                            .replace(/&amp;frasl;|&frasl;/g, '/')
                        )
                      : ''
                  }
                  style={{ width: '100%' }}
                  fullWidth
                  onChange={e => {
                    setSelectedClub({
                      ...club,
                      mainbtn2: { ...club.mainbtn2, url: { _text: e.target.value } }
                    })
                  }}
                />
              </InputContainer>
            </Row>
          </Col>
        </Row>
      </DataContainer>
    </>
  )
}
